import React, { FC, useCallback } from "react";
import { PentrackerUser } from "../../../../../../domain/user/User";
import { FixedSizeList as List } from "react-window";
import { AutoSizer, Size } from "react-virtualized";
import { TicketSearchRow } from "./row";
import { EmptyState } from "../../../../../components/state/empty";
import { faList, faSearch } from "@fortawesome/free-solid-svg-icons";
import { AppTicketFileType } from "../../../../../../domain/ticket/UserTicket";

export type UserSearchListProps = {
  // items: PentrackerUser[] | null;
  items: AppTicketFileType[] | undefined;
  onClick: (user: AppTicketFileType) => void;
};

export type UserSearchListRowProps = {
  items: AppTicketFileType[] | undefined;
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

export const TicketSearchListWindow: FC<UserSearchListProps> = ({
  items,
  onClick,
}) => {
  /* eslint-disable */
  const onRowClick = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if (!items) return;
      const index = e.currentTarget.dataset.index;
      if (index) {
        onClick(items[index as unknown as number]);
      }
    },
    [items]
  );

  /* eslint-enable */

  if (items === undefined) {
    return (
      <EmptyState
        icon={faSearch}
        title={"Buscar Usuario"}
        message={"Ingrese un término de búsqueda."}
      />
    );
  }

  return items === null ? (
    <EmptyState
      icon={faSearch}
      title={"Buscar Usuario"}
      message={"Ingrese un término de búsqueda."}
    />
  ) : items.length > 0 ? (
    //@ts-ignore
    <AutoSizer>
      {(props: Size) => (
        <List
          height={props.height}
          itemCount={items?.length || 0}
          itemSize={90}
          width={props.width}
          itemData={{
            items,
            onClick: onRowClick,
          }}
        >
          {TicketSearchRow}
        </List>
      )}
    </AutoSizer>
  ) : (
    <EmptyState
      icon={faList}
      title={"Sin resultados"}
      message={`No hay usuarios que coincidan con la búsqueda.`}
    />
  );
};
